module.exports = __webpack_public_path__ + "img/IMAGE00007.84705801.jpeg";